"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrossSellChannel = void 0;
const topic_1 = require("../../topic");
const CROSS_SELL_CHANNEL = 'crossSell';
class CrossSellChannel {
    constructor(_logger) {
        this._logger = _logger;
        this.channel = CROSS_SELL_CHANNEL;
        this.topics = {
            CTA_CasinoClient_GetURL: new topic_1.Topic('CTA_CasinoClient_GetURL', CROSS_SELL_CHANNEL, this._logger),
            CTA_CasinoClient_Open: new topic_1.Topic('CTA_CasinoClient_Open', CROSS_SELL_CHANNEL, this._logger),
            CTA_SportClient_Open: new topic_1.Topic('CTA_SportClient_Open', CROSS_SELL_CHANNEL, this._logger),
            CTA_LiveDealer_Open: new topic_1.Topic('CTA_LiveDealer_Open', CROSS_SELL_CHANNEL, this._logger),
            CTA_Vegas_Open: new topic_1.Topic('CTA_Vegas_Open', CROSS_SELL_CHANNEL, this._logger),
            CTA_PokerClient_Open: new topic_1.Topic('CTA_PokerClient_Open', CROSS_SELL_CHANNEL, this._logger),
            CTA_SchleswigHolsteinGGPGame_Open: new topic_1.Topic('CTA_SchleswigHolsteinGGPGame_Open', CROSS_SELL_CHANNEL, this._logger),
        };
    }
}
exports.CrossSellChannel = CrossSellChannel;
//# sourceMappingURL=cross-sell.channel.js.map